import React from "react";
import { Helmet } from "react-helmet-async";
import { normalizeCanonicalPath } from "../utils/seo";

interface PropsMetaData {
  title: string;
  description: string;
  canonicalLink?: string;
  imageOG?: string;
  imageAltOG?: string;
  imageWidthOG?: number;
  imageHeightOG?: number;
  imageTypeOG?: string;
  titleOG?: string;
  descriptionOG?: string;
  type?: string;
  robots?: string;
}

export const MetaData: React.FC<PropsMetaData> = ({
  title,
  description,
  canonicalLink,
  type = "website",
  imageOG,
  imageAltOG,
  imageWidthOG,
  imageHeightOG,
  imageTypeOG,
  titleOG,
  descriptionOG,
  robots,
}) => {
  const normalizedCanonicalLink = canonicalLink ? normalizeCanonicalPath(canonicalLink) : undefined;
  const socialTitle = titleOG || title;
  const socialDescription = descriptionOG || description;

  return (
    <Helmet>
      <title>{title}</title>
      {normalizedCanonicalLink && <link rel="canonical" href={normalizedCanonicalLink} />}
      <meta name="description" content={description} />
      {robots && <meta name="robots" content={robots} />}
      <meta property="og:title" content={socialTitle} />
      <meta property="og:description" content={socialDescription} />
      {normalizedCanonicalLink && <meta property="og:url" content={normalizedCanonicalLink} />}
      <meta property="og:type" content={type} />
      {imageOG && <meta property="og:image" content={imageOG} />}
      {imageOG && imageTypeOG && <meta property="og:image:type" content={imageTypeOG} />}
      {imageOG && imageWidthOG && <meta property="og:image:width" content={String(imageWidthOG)} />}
      {imageOG && imageHeightOG && <meta property="og:image:height" content={String(imageHeightOG)} />}
      {imageOG && imageAltOG && <meta property="og:image:alt" content={imageAltOG} />}
      <meta name="twitter:card" content={imageOG ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={socialTitle} />
      <meta name="twitter:description" content={socialDescription} />
      {imageOG && <meta name="twitter:image" content={imageOG} />}
      {imageOG && imageAltOG && <meta name="twitter:image:alt" content={imageAltOG} />}
    </Helmet>
  );
};
